export default "__VITE_ASSET__cdc7a061__"